import application from 'application/application';

application.service('downloadService', [
	'API',
	'helper',
	'$http',
	'notification',
	function(API, helper, $http, notification) {
		this.serviceDownload = (params, rota) => {
			$('#modalDownload').modal('hide');

			$http({
				...helper.http(API.downloads, rota),
				params: {
					...params
				},
				responseType: 'blob',
				noCancelOnRouteChange: true
			}).then(response => {
				const { data, status } = response;

				if (status > 299) {
					return notification.danger('Download não concluído.');
				}

				const regex = /filename=(.*);/;
				const contentDispositionHeader =
					response.headers()['content-disposition'] ||
					`attachment; filename=${Date.now()}.pdf; filename*=UTF-8''${Date.now()}.pdf`;

				const [, filename] = regex.exec(contentDispositionHeader);

				const file = data;

				const linkEl = document.createElement('a');

				linkEl.href = URL.createObjectURL(file);

				linkEl.download = filename;

				document.body.appendChild(linkEl);

				linkEl.click();

				notification.success('Download concluído!');
			});
		};

		this.attachmentDownload = async (
			attachmentId,
			fileType = 'pdf',
			printing,
			anexo
		) => {
			const groupUserSelected = localStorage.getItem('__groupSelected__');
			const groupID = localStorage.getItem('__idGroupUserData__');

			await $http({
				...helper.http(API.attachmentDownload, 'GET', {
					ID: attachmentId
				}),
				params: {
					tipoArquivo: fileType,
					idGrupoUsuarios: groupUserSelected ? groupID : null
				},
				responseType: 'blob'
			}).then(response => {
				const { data, status } = response;

				if (status > 299) {
					if (anexo.flArquivoRestrito == true) {
						return notification.danger(
							'Anexo restrito, as informações não podem ser acessadas.'
						);
					} else {
						return notification.danger('Download não concluído.');
					}
				}

				const regex = /filename=(.*);/;

				const contentDispositionHeader =
					response.headers()['content-disposition'] ||
					`attachment; filename=${Date.now()}.pdf; filename*=UTF-8''${Date.now()}.pdf`;

				const [, filename] = regex.exec(contentDispositionHeader);

				const file = new Blob([data], { type: 'application/pdf' });

				const linkEl = document.createElement('a');

				linkEl.href = URL.createObjectURL(file);

				linkEl.download = filename;

				document.body.appendChild(linkEl);

				linkEl.click();

				notification.success('Download concluído!');
			});
		};
	}
]);
